<template>
  <div class="sidebar">
    <div class="main">
      <el-tooltip placement="left">
        <div slot="content">联系电话：15548350699</div>
        <el-button>
          <i class="iconfont icon-telephone"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip placement="left">
        <div slot="content" class="text">
          <img src="../assets/aotuo/kf.png" alt="" width="80px" /><br />联系客服
        </div>
        <el-button>
          <i class="iconfont icon-qrcode"></i>
        </el-button>
      </el-tooltip>
      <!-- 弹框 -->
      <!-- <el-button class="btn" @click="open" >
        <i class="iconfont icon-beizhu_note"></i>
      </el-button> -->
      <!-- <div class="tp" v-show="tc">
        <img src="../assets/wx.png" alt="" width="80px" />
      </div>
      <el-button type="text" @click="dk"
        ><i class="iconfont icon-beizhu_note"></i
      ></el-button> -->
    </div>
    <!-- 置顶 -->
    <el-backtop :bottom="50" :right="0" :visibility-height="100">
      <div><i class="el-icon-caret-top"></i></div>
    </el-backtop>
  </div>
</template>
<script>
export default {
  name: "Sidebar",
  components: {},
  data() {
    return {
      launage: "",
      tc: false,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    open() {
      const weiXinUrl = require("../assets/tc.jpg");
      this.$alert(
        "<img src=" + weiXinUrl + " width=100% >",
        {
          dangerouslyUseHTMLString: true,
          lockScroll: false,
          showConfirmButton: false,
          showClose:false,
          closeOnClickModal:true,
          closeOnPressEscape:true
        }
      );
    },
    // dk() {
    //   this.tc = true;
    // },
  },
};
</script>
<style lang="less" scoped>
.tp {
  width: 100%;
  height: 100%;
  float: left;
  background: chocolate;
}
.main {
  width: 40px;
  position: fixed;
  z-index: 2;
  bottom: 100px;
  right: 0;
  box-sizing: border-box;
}
.text {
  text-align: center;
}
.el-button {
  padding: 6px 7px;
  margin-left: 0px;
}
.iconfont {
  font-size: 28px;
}
.el-backtop,
.el-calendar-table td.is-today {
  color: #fa9600;
  font-size: 22px;
}
.el-button:focus,
.el-button:hover {
  color: #fa9600;
  border-color: #fa9600;
  background-color: #fff;
}
.btn {
  padding: 6px 7px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
  .iconfont {
    font-size: 26px;
  }
}
.btn:hover {
  color: #fa9600;
  border-color: #fa9600;
}
</style>
